export default __webpack_public_path__ + "static/media/logo.cc025f72.png";